/* eslint-disable */
export default {
  noRecords: 'Nessun record recente corrispondente.',
  inBound: 'In entrata',
  outBound: 'In uscita',
  missed: 'Chiamata persa',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
